import type { PublicApiKey } from '@/apilib';
import type { createComponentsStageModesApi } from './componentsStageModesWrapper';

export const ComponentsStageModesApiKey: PublicApiKey<
  typeof createComponentsStageModesApi
> = {
  name: 'ComponentsStageModesApi',
  public: true,
};
